export default __webpack_public_path__ + "static/media/468.faf2f43d.jpg";